import { render, staticRenderFns } from "./ActionEvents.vue?vue&type=template&id=068baddd&scoped=true"
import script from "./ActionEvents.vue?vue&type=script&lang=js"
export * from "./ActionEvents.vue?vue&type=script&lang=js"
import style0 from "./ActionEvents.vue?vue&type=style&index=0&id=068baddd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068baddd",
  null
  
)

export default component.exports